import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const benTrades: SeasonTrades[] = [
]